import apiHandler from './apiHandler';

const { publicRequest, commonRequest, tenantRequest } = apiHandler;

function getSpecificDevice({ id, signal }) {

  const params = { id };
  const cleanParams = JSON.parse(JSON.stringify(params || {}));
  const queryParams = new URLSearchParams(cleanParams);
  return tenantRequest(`/devices/?${queryParams}`, {
    reqAuth: true,
    signal,
  });

}

function getSpecificInverter({ id, signal } = {}) {

  const method = 'GET';
  return tenantRequest(`/devices/inverters/${id}`, {
    reqAuth: true,
    method,
    signal,
  });

}

function getSpecificInverterModel({ id, signal }) {

  const params = { id };
  const cleanParams = JSON.parse(JSON.stringify(params || {}));
  const queryParams = new URLSearchParams(cleanParams);
  return tenantRequest(`/devices/inverter-models/?${queryParams}`, {
    reqAuth: true,
    signal,
  });

}

function devices({
  next, client, search, ordering = 'id', signal,
} = {}) {

  const params = { client, search, ordering };
  const cleanParams = JSON.parse(JSON.stringify(params || {}));
  const queryParams = new URLSearchParams(cleanParams);

  if (next) {

    return commonRequest(next, {
      reqAuth: true,
      signal,
    });

  }

  return publicRequest(`/devices/?${queryParams}`, {
    reqAuth: true,
    signal,
  });

}

function devicesTelemetry({
  client, search, offset, limit, ordering, signal,
} = {}) {

  const params = {
    client, search, ordering, offset, limit,
  };
  const cleanParams = JSON.parse(JSON.stringify(params || {}));
  // eslint-disable-next-line no-unused-vars
  const queryParams = new URLSearchParams(cleanParams);

  return publicRequest('/devices/?skip=0&limit=1000&order_by=id', {
    reqAuth: true,
    signal,
  });

}

function getAllGateway({
  client, search, offset, limit, ordering, signal,
} = {}) {

  const params = {
    client, search, ordering, offset, limit,
  };
  const cleanParams = JSON.parse(JSON.stringify(params || {}));
  // eslint-disable-next-line no-unused-vars
  const queryParams = new URLSearchParams(cleanParams);

  return publicRequest('/devices/gateways/?skip=0&limit=1000&order_by=id', {
    reqAuth: true,
    signal,
  });

}

function getAllGatewayByBusiness(
  signal, skip = 0, limit = 1000, business_type_id,
) {

  const method = 'GET';
  return publicRequest(`/devices/gateways/?skip=${skip}&limit=${limit}&order_by=id&${business_type_id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getLogs({
  limit, start_date, end_date, device, level, signal, search,
} = {}) {

  const params = {
    limit, start_date, end_date, device, level, search,
  };
  const cleanParams = JSON.parse(JSON.stringify(params || {}));
  const queryParams = new URLSearchParams(cleanParams);
  const method = 'GET';
  return tenantRequest(`/device-events/device-logs?${queryParams}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getLogsInverter({
  limit, start_date, end_date, device, level, signal, inverter, name,
} = {}) {

  const params = {
    limit, start_date, end_date, device, level, inverter, name,
  };
  const cleanParams = JSON.parse(JSON.stringify(params || {}));
  const queryParams = new URLSearchParams(cleanParams);
  const method = 'GET';
  return tenantRequest(`/device-events/inverter-events?${queryParams}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllDevice({ signal, skip = 0, limit = 1000 }) {

  const method = 'GET';
  return publicRequest(`/devices/?skip=${skip}&limit=${limit}&order_by=id`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllDeviceByBusiness({
  signal, skip = 0, limit = 1000, business_type_id,
}) {

  const method = 'GET';
  return publicRequest(`/devices/?skip=${skip}&limit=${limit}&order_by=id&business_type_id=${business_type_id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllDeviceByBusiness2(
  signal, skip = 0, limit = 1000, business_type_id = '',
) {

  const method = 'GET';
  return publicRequest(`/devices/?skip=${skip}&limit=${limit}&order_by=id&${business_type_id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllClients({ signal, skip = 0, limit = 1000 }) {

  const method = 'GET';
  return publicRequest(`/devices/clients/?skip=${skip}&limit=${limit}&order_by=id`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllClientsByBusiness(
  signal, skip = 0, limit = 1000, business_type_id,
) {

  const method = 'GET';
  return publicRequest(`/devices/clients/?skip=${skip}&limit=${limit}&order_by=id&${business_type_id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getClientId({ signal, id }) {

  const method = 'GET';
  return publicRequest(`/devices/clients/${id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function createDevice({ signal, body }) {

  const method = 'POST';
  return publicRequest('/devices/', {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function createClient({ signal, body }) {

  const method = 'POST';
  return publicRequest('/devices/clients/', {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function updateClient({ signal, id, body }) {

  const method = 'PATCH';
  return publicRequest(`/devices/clients/${id}`, {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function deleteClientById({ signal, id }) {

  const method = 'DELETE';
  return publicRequest(`/devices/clients/${id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function createGateway({ signal, body }) {

  const method = 'POST';
  const headers = {
    businessid: body.busines_id,
  };

  return publicRequest('/devices/gateways/', {
    method,
    reqAuth: true,
    body,
    signal,
    headers,
  });

}

function createBusinessType({ signal, formData }) {

  const method = 'POST';
  const headers = {
    Accept: 'application/json',
    'Content-Type': '',
  };
  return publicRequest('/devices/business_type/', {
    method,
    reqAuth: true,
    formData,
    signal,
    headers,
  });

}

function createBusinessTypeCommunitie({ signal, body }) {

  console.log(body);

  const method = 'POST';
  return publicRequest('/devices/business_type/community/', {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function updateBusinessTypeCommunitie({ signal, id, body }) {

  const method = 'PATCH';
  return publicRequest(`/devices/business_type/community/${id}`, {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function createFirmware({ signal, formData, busines_id }) {

  const method = 'POST';
  const headers = {
    Accept: 'application/json',
    'Content-Type': '',
    businessid: busines_id,
  };
  return publicRequest('/devices/firmwares/', {
    method,
    reqAuth: true,
    formData,
    signal,
    headers,
  });

}

function createPortal({ signal, formData }) {

  const method = 'POST';
  const headers = {
    Accept: 'application/json',
    'Content-Type': '',
  };
  return publicRequest('/devices/portals/', {
    method,
    reqAuth: true,
    formData,
    signal,
    headers,
  });

}

function createModelInverter({ signal, body }) {

  const method = 'POST';
  return publicRequest('/devices/inverter-models/', {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function enableCSDevice({ signal, body, id }) {

  const method = 'POST';
  return publicRequest(`/devices/${id}/enable-check-cs`, {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function enableCSGateway({ signal, body, id }) {

  const method = 'POST';
  return publicRequest(`/devices/gateways/${id}/enable-check-cs`, {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function createDeviceType({ signal, body }) {

  const method = 'POST';
  return publicRequest('/devices/device_type/', {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function createDeviceTypeUnified({ signal, body }) {

  const method = 'POST';
  const headers = {
    businessid: body.busines_id,
  };
  return publicRequest('/devices/device_type/unified/', {
    method,
    reqAuth: true,
    body,
    signal,
    headers,
  });

}

function getAllFirmwares({ signal, skip = 0, limit = 1000 }) {

  const method = 'GET';
  return publicRequest(`/devices/firmwares/?skip=${skip}&limit=${limit}&order_by=id`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllFirmwaresByBusiness(
  signal, skip = 0, limit = 1000, business_type_id,
) {

  const method = 'GET';
  return publicRequest(`/devices/firmwares/?skip=${skip}&limit=${limit}&order_by=id&${business_type_id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllModelInverters({ signal, skip = 0, limit = 1000 }) {

  const method = 'GET';
  return publicRequest(`/devices/inverter-models/?skip=${skip}&limit=${limit}&order_by=id`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllPortal({ signal, skip = 0, limit = 1000 }) {

  const method = 'GET';
  return publicRequest(`/devices/portals/?skip=${skip}&limit=${limit}&order_by=id`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllDeviceId({ signal, skip, limit }) {

  const method = 'GET';
  return publicRequest(`/devices/?skip=${skip}&limit=${limit}&order_by=id`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllDeviceName({
  signal, name, skip = 0, limit = 1000,
}) {

  const method = 'GET';
  return publicRequest(`/devices/?skip=${skip}&limit=${limit}&order_by=id&name=${name}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getOneDeviceId({ signal, id }) {

  const method = 'GET';
  return publicRequest(`/devices/inverters/${id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function deleteDeviceById({ signal, id }) {

  const method = 'DELETE';
  return publicRequest(`/devices/${id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function deleteGatewayById({ signal, id }) {

  const method = 'DELETE';
  return publicRequest(`/devices/gateways/${id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function deleteBusinessType({ signal, id }) {

  const method = 'DELETE';
  return publicRequest(`/devices/business_type/${id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function deleteDeviceTypeUnified({ signal, id }) {

  const method = 'DELETE';
  return publicRequest(`/devices/device_type/${id}/unified/`, {
    reqAuth: true,
    signal,
    method,
  });

}

function deleteFirmwareById({ signal, id }) {

  const method = 'DELETE';
  return publicRequest(`/devices/firmwares/${id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function deletePortalById({ signal, id }) {

  const method = 'DELETE';
  return publicRequest(`/devices/portals/${id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function deleteModelInverterById({ signal, id }) {

  const method = 'DELETE';
  return publicRequest(`/devices/inverter-models/${id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function editDevice({ signal, id, body }) {

  const method = 'PATCH';
  return publicRequest(`/devices/${id}`, {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function editGateway({ signal, id, body }) {

  const method = 'PATCH';
  return publicRequest(`/devices/gateways/${id}`, {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function editDeviceTypeUnified({ signal, id, body }) {

  const method = 'PATCH';
  return publicRequest(`/devices/device_type/${id}/unified/`, {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function deviceTwin({ signal, body }) {

  const method = 'POST';
  return publicRequest('/devices/device_twin/', {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function editBusinessType({
  signal, id, formData,
}) {

  const method = 'PATCH';
  const headers = {
    Accept: 'application/json',
    'Content-Type': '',
  };
  return publicRequest(`/devices/business_type/${id}`, {
    method,
    reqAuth: true,
    formData,
    signal,
    headers,
  });

}

function editFirmware({ signal, id, body }) {

  const method = 'PATCH';
  return publicRequest(`/devices/firmwares/${id}`, {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function editFirmwareData({ signal, id, formData }) {

  const method = 'PATCH';
  const headers = {
    Accept: 'application/json',
    'Content-Type': '',
  };
  return publicRequest(`/devices/firmwares/${id}`, {
    method,
    reqAuth: true,
    formData,
    signal,
    headers,
  });

}

function editPortalData({ signal, id, formData }) {

  const method = 'PATCH';
  const headers = {
    Accept: 'application/json',
    'Content-Type': '',
  };
  return publicRequest(`/devices/portals/${id}`, {
    method,
    reqAuth: true,
    formData,
    signal,
    headers,
  });

}

function editModelInverter({ signal, id, body }) {

  const method = 'PATCH';
  return publicRequest(`/devices/inverter-models/${id}`, {
    method,
    reqAuth: true,
    body,
    signal,
  });

}

function partialUpdateAlarm({ id, body, signal } = {}) {

  return tenantRequest(`/devices/${id}/enable-check-cs`, {
    reqAuth: true,
    method: 'POST',
    body,
    signal,
  });

}

function getDeviceId({ signal, id }) {

  const method = 'GET';
  return publicRequest(`/devices/${id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllBusinessType({ signal, skip = 0, limit = 1000 }) {

  const method = 'GET';
  return publicRequest(`/devices/business_type/?skip=${skip}&limit=${limit}&order_by=id`, {
    reqAuth: true,
    signal,
    method,
  });

}
function getAllBusinessTypeQuery({
 signal, skip = 0, limit = 1000, queryParams = '',
}) {

  const method = 'GET';
  return publicRequest(`/devices/business_type/?skip=${skip}&limit=${limit}&order_by=id${queryParams}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllBusinessTypeById({
  signal, skip = 0, limit = 1000, business_type_id,
}) {

  const method = 'GET';
  return publicRequest(`/devices/business_type/?skip=${skip}&limit=${limit}&order_by=id&id=${business_type_id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllDeviceType({ signal, skip = 0, limit = 1000 }) {

  const method = 'GET';
  return publicRequest(`/devices/device_type/?skip=${skip}&limit=${limit}&order_by=id`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllDeviceTypeUnified({ signal, skip = 0, limit = 1000 }) {

  const method = 'GET';
  return publicRequest(`/devices/device_type/unified/?skip=${skip}&limit=${limit}&order_by=id`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllDeviceTypeUnifiedByBusiness(signal, skip = 0, limit = 1000, business_type_id) {

  const method = 'GET';
  return publicRequest(`/devices/device_type/unified/?skip=${skip}&limit=${limit}&order_by=id&${business_type_id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

function getAllDevicesByDevicesType({
  signal, skip = 0, limit = 1000, device_type_id,
}) {

  const method = 'GET';
  return publicRequest(`/devices/?skip=${skip}&limit=${limit}&order_by=id&device_type_id=${device_type_id}`, {
    reqAuth: true,
    signal,
    method,
  });

}

export default {
  devices,
  devicesTelemetry,
  getAllGateway,
  getAllGatewayByBusiness,
  getLogs,
  getSpecificDevice,
  getSpecificInverter,
  getSpecificInverterModel,
  getAllDevice,
  createDevice,
  createDeviceType,
  createDeviceTypeUnified,
  createGateway,
  getAllFirmwares,
  getAllFirmwaresByBusiness,
  getAllPortal,
  deleteDeviceById,
  deleteGatewayById,
  deleteFirmwareById,
  deletePortalById,
  editDevice,
  editGateway,
  editDeviceTypeUnified,
  deviceTwin,
  enableCSDevice,
  enableCSGateway,
  createFirmware,
  createPortal,
  editFirmware,
  getAllModelInverters,
  createModelInverter,
  editModelInverter,
  deleteModelInverterById,
  getLogsInverter,
  getAllDeviceId,
  getOneDeviceId,
  getAllDeviceName,
  partialUpdateAlarm,
  getDeviceId,
  getAllBusinessType,
  getAllDeviceType,
  getAllDeviceTypeUnified,
  getAllDeviceTypeUnifiedByBusiness,
  getAllDeviceByBusiness,
  getAllDeviceByBusiness2,
  getAllClients,
  getAllClientsByBusiness,
  getClientId,
  getAllBusinessTypeById,
  editFirmwareData,
  editPortalData,
  createBusinessType,
  createBusinessTypeCommunitie,
  updateBusinessTypeCommunitie,
  editBusinessType,
  deleteBusinessType,
  deleteDeviceTypeUnified,
  getAllDevicesByDevicesType,
  getAllBusinessTypeQuery,
  createClient,
  updateClient,
  deleteClientById,
};
